import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import PropertyCard from 'components/PropertyCard';
import { animationKeyframes } from 'lib/animations';
import { useDataLayer } from 'hooks/useDataLayer';
import { usePersonalisation } from 'hooks/usePersonalisation';

const AnimationWrapper = styled(Box)`
  flex: 1 1 auto;
  animation: ${animationKeyframes.fadeInSlideUp10} ease 250ms;
  margin-bottom: ${themeGet('space.4')};
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const FixedPropertyCard = (props) => {
  const { id: propertyId } = props;
  const { emitInteractionEvent } = useDataLayer();
  const personalisation = usePersonalisation();
  const handlePropertyCardClick = useCallback(() => {
    emitInteractionEvent({ type: 'Price Marker', value: 'Property Card Selected' });
    personalisation.trackMapClick(propertyId);
  }, [propertyId, personalisation, emitInteractionEvent]);

  return (
    <AnimationWrapper data-testid="fixed-property-card-wrapper">
      <PropertyCard inline onClick={handlePropertyCardClick} {...props} m={0} />
    </AnimationWrapper>
  );
};

FixedPropertyCard.propTypes = {
  ...PropertyCard.propTypes,
};

export default FixedPropertyCard;
